setTimeout(() => {
document.querySelectorAll('.flickity-viewport').forEach(container => {
    
  const vwChild = container.querySelector('.vw-product-widgets-container');
  if (vwChild) {
    const currentMaxHeight = container.style.maxHeight || getComputedStyle(container).maxHeight;
    if (!currentMaxHeight || currentMaxHeight === 'none' || currentMaxHeight === '0px') {
      container.style.maxHeight = '425px'; 
    } 
  }
});
}, 2000);
  
